import React from 'react';
import { Link } from './Link.js';

const BurgerPrimary = ({ className = '', closeLabel = 'Close', closeIndicatorClassName = '', onClick, open = false, openIndicatorClassName = '', openLabel = 'Open', ...rest }) => {
    const hiddenClassNames = 'opacity-0 invisible';
    const toggleClassNames = 'duration-200 col-span-full row-span-full transition-all';
    return (React.createElement(Link, { className: [
            'grid items-center justify-items-center w-10 relative z-30',
            className,
        ].join(' '), role: "button", onClick: onClick, ...rest },
        React.createElement("svg", { focusable: "false", role: "img", viewBox: "0 0 59 20", xmlns: "http://www.w3.org/2000/svg", className: [
                toggleClassNames,
                open ? hiddenClassNames : '',
                openIndicatorClassName,
            ].join(' ') },
            React.createElement("title", null, openLabel),
            React.createElement("path", { d: "M59 0v1H0V0zM59 19v1H0v-1zM59 10v1H0v-1z" })),
        React.createElement("span", { className: [
                'underline',
                toggleClassNames,
                open ? '' : hiddenClassNames,
                closeIndicatorClassName,
            ].join(' ') }, closeLabel)));
};
const BurgerSecondary = ({ className, open, onClick }) => {
    return (React.createElement("span", { className: [className, 'flex z-30'].join(' '), onClick: onClick },
        React.createElement("label", { className: "leafwell-burger-menu-secondary" },
            React.createElement("input", { type: "checkbox", checked: !open, readOnly: true }),
            React.createElement("div", null,
                React.createElement("span", null),
                React.createElement("span", null)))));
};
const Burger = ({ layout = 'primary', ...burgerProps }) => {
    return layout === 'primary' ? (React.createElement(BurgerPrimary, { ...{ ...burgerProps } })) : (React.createElement(BurgerSecondary, { className: burgerProps.className, onClick: burgerProps.onClick, open: burgerProps.open }));
};

export { Burger, BurgerSecondary };
//# sourceMappingURL=Burger.js.map
